"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginProvider = LoginProvider;
exports.useLogin = useLogin;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const LoginClientContext = /*#__PURE__*/_react.default.createContext(null);
function LoginProvider({
  children,
  client
}) {
  return /*#__PURE__*/_react.default.createElement(LoginClientContext.Provider, {
    value: client
  }, children);
}
function useLogin() {
  const client = _react.default.useContext(LoginClientContext);
  if (!client) {
    throw new Error('useLoginClient must be used within a LoginProvider');
  }
  const [state, setState] = _react.default.useState(client.getState());
  _react.default.useEffect(() => client.subscribe(() => setState(client.getState())), [client]);
  const onEmailChanged = _react.default.useCallback(value => {
    client.dispatch({
      type: 'SET_EMAIL',
      value
    });
  }, [client]);
  const onLoginRequest = _react.default.useCallback(returnPath => {
    client.dispatch({
      type: 'LOGIN',
      returnPath
    });
  }, [client]);
  const onLogout = _react.default.useCallback(() => {
    client.dispatch({
      type: 'LOGOUT'
    });
  }, [client]);
  return _react.default.useMemo(() => ({
    user: state.user,
    isAuthenticated: state.isAuthenticated,
    email: state.email,
    emailIsValid: state.emailIsValid,
    loggingIn: state.loggingIn,
    emailConfirmationRequired: state.emailConfirmationRequired,
    loginFailed: state.loginFailed,
    onEmailChanged,
    onLoginRequest,
    onLogout
  }), [state, onEmailChanged, onLoginRequest, onLogout]);
}